const copy = {
  redirectButtonValue: "Back to SendGrid Help Center",
  oneSupportCenterForm: {
    attachments: {
      label: "Attach files",
    },
    businessImpact: {
      p1: "1 - P1 Critical Outage",
      p2: "2 - P2 Degraded",
      p3: "3 - P3 General",
    },
    comment: {
      error: "Please enter a description.",
      label: "Description",
      helpText: `Please provide all details above, including product and examples for us to troubleshoot, and we'll be in touch shortly.`,
    },
    email: {
      errors: {
        required: "Please enter your email.",
        invalidEmail: "Please enter a valid email address.",
      },
      label: "Email address",
    },
    followUpQuestions: {
      error: "Please enter an answer to the question above.",
    },
    collaborators: {
      empty: "You have not yet added any CCs to this ticket.",
      errors: {
        invalidEmail: "Please enter a valid email address.",
        existingEmails: (existingEmails: string[]): string =>
          `${existingEmails.join(
            ", "
          )} was already added. Enter a different email.`,
        duplicateEmails: (duplicateEmails: string[]): string =>
          `${duplicateEmails.join(
            ", "
          )} was entered multiple times.  Enter a different email.`,
      },
      label: "CCs",
      help: "Enter email addresses, comma separated.",
      placeholder: "example@twilio.com",
    },
    header: "Submit a ticket",
    legal: {
      part1:
        "Please do not include any personal data, including sensitive personal data, in the support request or attachments to your request.",
      part2:
        "Twilio analyzes the type, frequency and patterns of requests we receive to help identify ways to improve our support services and anonymizes any personal data prior to conducting the analysis.",
    },
    product: { label: "Product" },
    priorityLevel: {
      label: "Business impact",
    },
    subject: {
      error: "Please enter a subject.",
      label: "Subject",
    },
    submit: {
      buttonValue: "Submit",
      success: {
        header: "Your ticket has been submitted!",
        callout: "Please check your email inbox for further instructions",
      },
    },
  },
};

export default copy;
